<template>
  <b-card class="rounded-lg">
    <template #header>
      <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
        <h4 class="text-dark m-0">
          Notes
        </h4>
      </div>
    </template>
    

    <div class="" style="height: 480px; overflow-y: scroll;">
      <b-overlay :show="loading" opacity="0.5">
        <div>
          <list-table
            :records="records" 
            :columns="tableColumns"
            :current-page-number="1"
            :show-import-button="false"
            :show-export-button="false"
            :show-search="false"
            :total-records="totalRecords"
          >
            <template #cell(status)="data">
              <b-badge
                pill
                :variant="data.item.status === 'active' ? `light-success` : 'light-danger'"
                class="text-capitalize"
              >
                {{ getUserStatusText(data.item.status) }}
              </b-badge>
            </template>

            <template #cell(duration)="data">
              <span>
                {{ `${data.item.duration} ${startCase(data.item.duration_unit)}` }}
              </span>
            </template>
          </list-table>
        </div>
      </b-overlay>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BImg,
  BRow,
  BCol,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BOverlay,
  BDropdown,
  BDropdownItem,
  BDropdownGroup
} from 'bootstrap-vue'

import { get, startCase } from 'lodash';

import Ripple from 'vue-ripple-directive'
import ListTable from "@/@core/components/ListTable/ListTable.vue";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AddOrUpdateDieticiansNoteModal from '@/@core/components/shared/admin/modals/AddOrUpdateDieticiansNoteModal.vue';

export default {
  components: {
    BImg,
    BRow,
    BCol,
    BCard,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BOverlay,
    BDropdown,
    BDropdownItem,
    BDropdownGroup,

    ListTable,
    AddOrUpdateDieticiansNoteModal
  },
  directives: {
    Ripple,
  },
  props: {
    consultationData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,

      editingData: null,
      toggleModal: false,
      
      records: [],
      tableColumns: [
        { key: 'note', sortable: false, },
        { key: 'created', label: 'Date', sortable: false, formatter: val => `${this.formatDate(val, 'MM-yy')}`, class: 'w-10' },
      ],
    }
  },
  computed: {
    totalRecords: {
      get(){
        return this.$store.getters[`navigation/totalRecords`];
      },
      set(value){
        this.$store.commit(`navigation/UPDATE_TOTAL_RECORDS`, value)
      }
    },
  },
  created() {
    this.fetchAllData();
  },
  methods: {
    async fetchAllData() {
      try {
        this.loading = true; 

        const query = {
          page: 1,
          limit: 100,
          consultation_id: this.consultationData._id,
        }

        const request = await this.useJwt().mainService.dieticianNotes.list(query);
        const { data, pagination } = request.data;
        this.records = data;
        this.totalRecords = pagination.totalRecords
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    startCase
  }
}
</script>

<style scoped>
.profile-highlight {
  font-size: 18px !important;
}
.profile-highlight-title {
  font-size: 16px !important;
  color: lightgray;
  font-weight: normal;
}

.patient-name {
  font-size: 25px;
}
</style>

<style>
.w-10 {
  width: 13% !important;
}
</style>
